export default __webpack_public_path__ + "static/media/chevron_right_blue.6bdbaa4a.svg";